/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { Dispatch } from 'redux';
import { Orientations } from '../common/responsive';

export const updateMobileState = ({
  isMobileView,
  isMobileDevice,
  orientation,
}: {
  isMobileView: boolean;
  isMobileDevice: boolean;
  orientation: Orientations;
}) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: 'UPDATE_MOBILE_STATE',
      payload: {
        isMobileView,
        isMobileDevice,
        orientation,
      },
    });
  };
};
